export default __webpack_public_path__ + "static/media/expired.f27417a6.png";